import { z } from 'zod';

/**
 * Mensagens privadas streamer <-> padrinho (GS13). Uma conversa por streamer,
 * com o padrinho do momento; o Stream Staff le. As notas internas do Stream
 * Staff continuam escondidas do streamer.
 */

const datetimeSchema = z.string().datetime({ offset: true });

export const messageSchema = z.object({
  id: z.string().uuid(),
  author: z.string(),
  /** `me` = quem esta a ver; `streamer` / `padrinho` para o Stream Staff. */
  from: z.enum(['me', 'streamer', 'padrinho', 'other']),
  body: z.string(),
  createdAt: datetimeSchema,
});
export type Message = z.infer<typeof messageSchema>;

/** Uma conversa. `unread` conta as que eram novas antes de abrir (abrir marca como lidas). */
export const conversationSchema = z.object({
  streamer: z.object({ id: z.string().uuid(), displayName: z.string(), login: z.string() }),
  padrinho: z.object({ accountId: z.string().uuid(), login: z.string() }).nullable(),
  unread: z.number().int(),
  messages: z.array(messageSchema),
});
export type Conversation = z.infer<typeof conversationSchema>;

export const messageInputSchema = z.object({
  body: z.string().trim().min(1, 'escreve a mensagem').max(2000),
});
export type MessageInput = z.infer<typeof messageInputSchema>;
